// src/services/agentApi.ts
import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

export interface AgentRequestPayload {
  user_id?: string | null;
  user_query: string;
  app_project_id?: string | null;
  version_id?: string | null;
  project_type?: string | null;
  additional_context?: string | null;
  file_upload?: File | null;
  generate_video?: boolean;
  animate_video?: boolean;
}

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const agentApi = createApi({
  reducerPath: "agentApi",
  baseQuery: createCustomBaseQuery(
    `${API_BASE_URL}/agent/`
  ),
  endpoints: (builder) => ({
    runAgent: builder.mutation<any, AgentRequestPayload>({
      query: (payload) => {
        const formData = new FormData();

        formData.append("user_query", payload.user_query);

        if (payload.user_id) formData.append("user_id", payload.user_id);
        if (payload.app_project_id)
          formData.append("app_project_id", payload.app_project_id);
        if (payload.version_id)
          formData.append("version_id", payload.version_id);
        if (payload.project_type)
          formData.append("project_type", payload.project_type);
        if (payload.additional_context)
          formData.append("additional_context", payload.additional_context);
        if (payload.file_upload)
          formData.append("file_upload", payload.file_upload);
        if (payload.generate_video !== undefined) {
          formData.append("generate_video", String(payload.generate_video));
        }
        if (payload.animate_video !== undefined) {
          formData.append("animate_video", String(payload.animate_video));
        }

        return {
          url: "/agent",
          method: "POST",
          body: formData,
        };
      },
    }),
  }),
});

export const { useRunAgentMutation } = agentApi;
